import React from 'react';
import Image from '../Image';
import RichTextRenderer from '../richTextRenderer';
import Button from '../button';
import { Text } from '../../interfaces/text';
import { buttonInterface } from '../../interfaces/button';
import { Image as ImageInterface } from '../../interfaces/image';
interface CtaInterface {
  data: {
    body: Text;
    ctaType: string;
    button: Array<buttonInterface>;
    image: ImageInterface | ImageLottie;
  };
}

type ImageLottie = {
  body: Text;
};

function Cta({ data }: CtaInterface) {
  const { body, button, ctaType, image } = data;

  return (
    <div className={`cl-cta cl-cta--${ctaType ?? 'primary'}`}>
      <div className='cl-cta__text'>
        <RichTextRenderer text={body} fontSize='lg' />

        <Button data={button[0]} />
      </div>

      <div className='cl-cta__media'>
        {isImageLottie(image) ? <RichTextRenderer text={image.body} /> : <Image data={image} />}
      </div>
    </div>
  );
}

function isImageLottie(image: ImageInterface | ImageLottie): image is ImageLottie {
  return (image as ImageLottie).body !== undefined;
}

export default Cta;
